import { Container, SVGPath, ViewBox } from '@acies/core';
import Label from './label';
import theme from './theme';

export default class FileExtension extends Container {
	/** The extension string will be displayed inside the blue box in the UI. */
	public set extension(value: string) {
		if (this.#extension === value) {
			return;
		}
		this.#extension = value;
		this.#extensionChanged = true;
		this.invalidateProperties();
	}

	public get extension(): string {
		return this.#extension;
	}

	#extension: string;
	#extensionChanged: boolean;
	#extensionContainer!: Container;
	#extensionLabel!: Label;
	#svgPath!: SVGPath;

	private get extensionContainer(): Container {
		if (!this.#extensionContainer) {
			this.#extensionContainer = new Container();
			this.#extensionContainer.alignment = 'left';
			this.#extensionContainer.position = 'absolute';
			this.#extensionContainer.left = 0;
			this.#extensionContainer.bottom = 6;
			this.#extensionContainer.paddingHorizontal = 3;
			this.#extensionContainer.height = 14;
			this.#extensionContainer.cornerRadius = 3;
			this.#extensionContainer.fill = theme.colors.icon.focused;
			this.#extensionContainer.addComponent(this.extensionLabel);
		}
		return this.#extensionContainer;
	}

	private get extensionLabel(): Label {
		if (!this.#extensionLabel) {
			this.#extensionLabel = new Label();
			this.#extensionLabel.fontSize = 8.8;
			this.#extensionLabel.lineHeight = 10;
			this.#extensionLabel.fill = theme.colors.text.white;
			this.#extensionLabel.fontWeight = 500;
			this.#extensionLabel.text = this.extension;
		}
		return this.#extensionLabel;
	}

	private get svgPath(): SVGPath {
		if (!this.#svgPath) {
			this.#svgPath = new SVGPath();
			this.#svgPath.width = 24;
			this.#svgPath.height = 30;
			this.#svgPath.viewBox = new ViewBox(0.75, 0.75, 24, 30);
			this.#svgPath.strokeWeight = 1.5;
			this.#svgPath.strokeColor = theme.colors.icon.soft;
			this.#svgPath.fill = theme.colors.icon.white;
			this.#svgPath.commands =
				'M15.75 1.154V7.35c0 .84 0 1.26.164 1.581a1.5 1.5 0 0 0 .655.656c.32.163.74.163 1.581.163h6.196m.404 2.982V23.55c0 2.52 0 3.78-.49 4.743a4.5 4.5 0 0 1-1.967 1.966c-.963.491-2.223.491-4.743.491h-9.6c-2.52 0-3.78 0-4.743-.49a4.5 4.5 0 0 1-1.967-1.967C.75 27.33.75 26.07.75 23.55V7.95c0-2.52 0-3.78.49-4.743A4.5 4.5 0 0 1 3.207 1.24C4.17.75 5.43.75 7.95.75h4.818c1.1 0 1.65 0 2.168.124a4.5 4.5 0 0 1 1.301.54c.454.277.844.667 1.622 1.445L22.64 7.64c.778.778 1.168 1.168 1.446 1.622.247.402.428.841.539 1.3.124.518.124 1.069.124 2.17Z';
		}
		return this.#svgPath;
	}

	public constructor() {
		super();
		this.width = 36;
		this.height = 36;
		this.alignment = 'center';
		this.#extension = 'EXT';
		this.#extensionChanged = false;
	}

	protected override commitProperties(): void {
		super.commitProperties();
		if (this.#extensionChanged) {
			this.#commitExtension();
		}
	}

	protected override initialize(): void {
		super.initialize();
		this.#createChildren();
	}

	#commitExtension(): void {
		this.#extensionChanged = false;
		this.extensionLabel.text = this.extension;
	}

	#createChildren(): void {
		this.addComponents([this.svgPath, this.extensionContainer]);
	}
}
customElements.define('ac-file-extension', FileExtension);
